import appSettings from 'wanderu-config';
import {
    fetchAllTripsAction,
    fetchCachedTripsAction,
} from 'wanderu-ducks-psearch';
import {
    cityToCitySelectors as c2cSelectors,
    cityToCityActions as c2cActions,
    fetchCityToCityAction,
} from 'wanderu-ducks-seo';
import { i18nMoment } from 'wanderu-i18n';
import Logger from 'wanderu-logger';
import { SnowplowService } from 'wanderu-service-analytics';

import {
    getPSearchParams,
} from '../../../utils';

const logger = Logger.getLogger('c2c');

function fetchTimeTableData(cityToCityId, opts = {}) {
    return async (dispatch, getState) => {
        const {
            date,
            isClient = true,
            path,
        } = opts;

        const locationData = c2cSelectors.selectLocationData(getState(), cityToCityId);

        let dateToSearch = date;
        if (!date) {
            const today = i18nMoment().tz(locationData.departure.timezone);
            dateToSearch = today.add(1, 'days').format('YYYY-MM-DD');
        }

        await Promise.all([
            dispatch(c2cActions.setSelectedTimeTableDate(cityToCityId, dateToSearch)),
            dispatch(fetchCachedTrips(cityToCityId, dateToSearch, path)),
            // temporarily removing jit calls from SEO pages SUP-751 - nw 11/07/2023
            // isClient
            //     ? dispatch(fetchAllTrips(cityToCityId, dateToSearch, path))
            //     : dispatch(fetchCachedTrips(cityToCityId, dateToSearch, path)),
        ]);
    };
}

function fetchCachedTrips(cityToCityId, date, path) {
    return async (dispatch, getState) => {
        try {
            const locationData = c2cSelectors.selectLocationData(getState(), cityToCityId);
            const psearchParams = getPSearchParams(locationData, date);

            psearchParams.routed = false;
            // removing any retries while we get Amtrak sorted out SUP-751 - nw 11/07/
            // psearchParams.retryRouted = true;
            psearchParams.retryRouted = false;

            await dispatch(fetchCachedTripsAction.fetch(psearchParams, path));
        } catch (ex) {
            const domainUserInfo = appSettings.env.isClient
                ? SnowplowService.getDomainUserInfo()
                : {};

            logger.error('fetchCachedTrips', ex, {
                snowplowIds: {
                    networkUserId: SnowplowService.getNetworkUserId(),
                    ...domainUserInfo,
                },
            });
        }
    };
}

function fetchAllTrips(cityToCityId, date, path) {
    return async (dispatch, getState) => {
        try {
            const locationData = c2cSelectors.selectLocationData(getState(), cityToCityId);
            const psearchParams = getPSearchParams(locationData, date);
            const cachedSuccess = fetchCachedTripsAction.selectSuccess(getState(), psearchParams);

            psearchParams.routed = false;
            psearchParams.retryRouted = true;

            if (!cachedSuccess) {
                dispatch(fetchCachedTripsAction.fetch(psearchParams, path));
            }

            await dispatch(fetchAllTripsAction.fetch(psearchParams, path));
        } catch (ex) {
            const domainUserInfo = appSettings.env.isClient
                ? SnowplowService.getDomainUserInfo()
                : {};

            logger.error('fetchAllTrips', ex, {
                snowplowIds: {
                    networkUserId: SnowplowService.getNetworkUserId(),
                    ...domainUserInfo,
                },

            });
        }
    };
}

function fetchCityToCityData(cityToCityId, params, opts) {
    return async (dispatch, getState) => {
        /* get c2c data */
        try {
            await dispatch(fetchCityToCityAction.fetchCityToCityData(cityToCityId, params));

            await dispatch(fetchTimeTableData(cityToCityId, opts));

            return c2cSelectors.selectContent(getState(), cityToCityId);
        } catch (ex) {
            logger.warn('fetchCityToCityData failed', ex, {
                cityToCityId,
                params,
            });
            throw (ex);
        }
    };
}
export {
    fetchCityToCityData,
    fetchTimeTableData,
};
